import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import {ifDefined} from 'lit/directives/if-defined.js';
import store from '../src/store';
import { toggleFavorite } from '../src/apiActions';
import { connect } from 'pwa-helpers/connect-mixin';
import '../components/slds-dropdown.js';
import { addNotification, hidePost } from '../src/store';
import { askToLogin } from '../src/store';
import { SldsBaseElement } from '../components/slds-base-element.js';

@customElement('post-save')
class PostSave extends connect(store)(SldsBaseElement) {
	@property({type: Object}) item = null;
	@property({type: Boolean}) favorite = false;
	@property({type: Array}) profileDropdown = [];
	@property({type: Boolean}) profileDropdownOpen = false;
	@property({type: Boolean}) loggedIn = false;

  stateChanged(state) {
    if (state.user) {
      this.loggedIn = true;
      this.profileDropdown = [
        {
          label: 'Block User',
          value: 'block'
        },
        {
          label: 'Report Post',
          value: 'report'
        },
        {
          label: 'Save Image',
          value: 'save'
        },
        {
          label: 'Hide Post',
          value: 'hide'
        }
      ];
    }
    else {
      this.loggedIn = false;
      this.profileDropdown = [
        {
          label: 'Save Image',
          value: 'save'
        },
        {
          label: 'Hide Post',
          value: 'hide'
        }
      ];
    }
  }

  toggleFavorite() {
    if (!this.loggedIn) {
      store.dispatch(askToLogin());
      return;
    }
    this.favorite = !this.favorite;
		store.dispatch(toggleFavorite(this.item, this.favorite));
  }

  dropdownSelect(e) {
		switch(e.detail.type) {
			case 'save':
				// store.dispatch(saveImage(this.item));
				const files = this.item.files;
				if (files && files.default) {
					const canvas = document.createElement('canvas');
					const ctx = canvas.getContext('2d');
					const fileUrl = files.default.file_url; // "http://localhost:8080/assets/ceAMpcmE3jQ.webp";
					const watermarkUrl = "/assets/watermark.svg"
					const img = new Image();
					img.crossOrigin = "anonymous";
					img.src = fileUrl;
			
					img.onload = () => {
						// Set canvas dimensions to match the image
						canvas.width = img.width;
						canvas.height = img.height;
		
						// Draw the original image
						ctx.drawImage(img, 0, 0);

						// Load the SVG watermark
						const watermark = new Image();
						watermark.crossOrigin = "anonymous";
						watermark.src = watermarkUrl;
		
						watermark.onload = () => {
							// Set the desired size and position for the watermark
							const watermarkWidth = 1500; // Adjust as needed
							const watermarkHeight = (watermark.height / watermark.width) * watermarkWidth;
							const positionX = img.width - watermarkWidth + 20 + img.width - 140 + (Math.random() * 10); // Randomize the value a bit
							const positionY = img.height - watermarkHeight - 20 + img.height - 50 + (Math.random() * 1);
							ctx.globalAlpha = 0.5; // Example: 80% opacity
							// Draw the SVG watermark on top of the image
							ctx.drawImage(watermark, positionX, positionY, watermarkWidth, watermarkHeight);
							ctx.globalAlpha = 1.0;
			
							// Trigger the download
							const link = document.createElement('a');
							link.href = canvas.toDataURL('image/jpeg', 0.8);
							link.download = this.item.url + '.jpeg';
							link.click();

							// Clean up
							URL.revokeObjectURL(img.src);
						}
					};
				}
				break;
			case 'block':
				// store.dispatch(blockUser(this.item));
				store.dispatch(addNotification({
					type: 'success',
					content: {
						heading: 'User blocked',
						// message: 'User blocked'
					}
				}));
				break;
			case 'hide':
				store.dispatch(hidePost(this.item));
				break;
			case 'report':
				// store.dispatch(reportPost(this.item));
				store.dispatch(addNotification({
					type: 'success',
					content: {
						heading: 'Post Reported',
						// message: 'Post reported'
					}
				}));
				break;
			default:
				break;
		}
  }

  updated(changedProperties) {
    if (changedProperties.has('item')) {
      this.favorite = this.item?.favorited;
    }
  }

  static styles = [
    super.styles,
    css`
      :host {
        --background-color2: var(--background-color);
        --text-color2: var(--text-color);
      }
		slds-dropdown {
			--background-color: var(--background-color2, #f3f3f3);
        --text-color: var(--text-color2);
      }
    `
  ];

  render() {
    return html`
			<ul class="slds-global-actions">
				<li class="slds-global-actions__item slds-m-right_none">
					<div class="slds-global-actions__favorites slds-dropdown-trigger slds-dropdown-trigger_click slds-m-right_none">
						<slds-dropdown @select="${this.dropdownSelect}" @blur="${() => this.profileDropdownOpen = false}" .open="${this.profileDropdownOpen}" .options="${this.profileDropdown}">
							<div class="slds-button-group" style="max-width: 5rem;">
								<button @click="${this.toggleFavorite}" class="${this.favorite ? 'slds-is-selected' : ''} slds-button slds-button_icon slds-global-actions__favorites-action slds-button_icon slds-button_icon-border slds-button_icon-small" aria-pressed="false" title="Toggle Favorites">
									<svg class="slds-button__icon" aria-hidden="true">
										<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#favorite"></use>
									</svg>
									<span class="slds-assistive-text">Toggle Favorite</span>
								</button>
								<button @click="${() => this.profileDropdownOpen = !this.profileDropdownOpen}" class="slds-button slds-button_icon slds-button_icon slds-button_icon-border slds-button_icon-small" title="View Favorites">
									<svg class="slds-button__icon slds-button__icon_small" aria-hidden="true">
										<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
									</svg>
									<span class="slds-assistive-text">View Menu</span>
								</button>
							</div>
						</slds-dropdown>
					</div>
				</li>
			</ul>
    `
  }
}